import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useHeight } from "../../hooks/index.js";
import { getEmbedSrc } from "../helpers/index.js";
const IframePlayer = (t0)=>{
    const $ = c(5);
    const { src } = t0;
    const { maxHeight } = useHeight();
    let t1;
    if ($[0] !== src) {
        t1 = getEmbedSrc(src);
        $[0] = src;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== maxHeight || $[3] !== t1) {
        t2 = /*#__PURE__*/ jsx("iframe", {
            src: t1,
            width: "100%",
            height: maxHeight,
            allow: "accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            allowFullScreen: true,
            title: "Embedded Video"
        });
        $[2] = maxHeight;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};
export { IframePlayer };
